<template>
  <v-container>
    <v-container>
      <v-sheet>
        <v-card-title>
          {{ $t("locationTitle") }}
          <v-dialog v-model="dialog" persistent max-width="1000px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon class="ml-3">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <v-card tile>
              <v-card-title>
                <span class="headline">{{ $t("locationEdit") }}</span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'name' + k"
                  :label="$t('locationName') + translation.language + '*'"
                  name="name"
                  type="text"
                  required
                  v-model="$v.location.translations.$each[k].name.$model"
                  @input="$v.location.translations.$each[k].name.$touch()"
                  @blur="$v.location.translations.$each[k].name.$touch()"
                ></v-text-field>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'address' + k"
                  :label="$t('locationAddress') + translation.language + '*'"
                  name="address"
                  type="text"
                  required
                  v-model="$v.location.translations.$each[k].address.$model"
                  @input="$v.location.translations.$each[k].address.$touch()"
                  @blur="$v.location.translations.$each[k].address.$touch()"
                ></v-text-field>
                <v-text-field
                  name="lat"
                  type="text"
                  required
                  v-model="location.lat"
                  @input="$v.location.lat.$touch()"
                  @blur="$v.location.lat.$touch()"
                ></v-text-field>
                <v-text-field
                  name="lng"
                  type="text"
                  required
                  v-model="location.lng"
                  @input="$v.location.lng.$touch()"
                  @blur="$v.location.lng.$touch()"
                ></v-text-field>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'distance' + k"
                  :label="$t('locationDistance') + translation.language + '*'"
                  name="distance"
                  type="text"
                  required
                  v-model="$v.location.translations.$each[k].distance.$model"
                  @input="$v.location.translations.$each[k].distance.$touch()"
                  @blur="$v.location.translations.$each[k].distance.$touch()"
                ></v-text-field>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'opening_times' + k"
                  :label="
                    $t('locationOpeningTimes') + translation.language + '*'
                  "
                  name="opening_times"
                  type="text"
                  required
                  v-model="
                    $v.location.translations.$each[k].opening_times.$model
                  "
                  @input="
                    $v.location.translations.$each[k].opening_times.$touch()
                  "
                  @blur="
                    $v.location.translations.$each[k].opening_times.$touch()
                  "
                ></v-text-field>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'payment_description' + k"
                  :label="$t('locationPayment') + translation.language + '*'"
                  name="payment_description"
                  type="text"
                  required
                  v-model="
                    $v.location.translations.$each[k].payment_description.$model
                  "
                  @input="
                    $v.location.translations.$each[
                      k
                    ].payment_description.$touch()
                  "
                  @blur="
                    $v.location.translations.$each[
                      k
                    ].payment_description.$touch()
                  "
                ></v-text-field>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'parking_description' + k"
                  :label="$t('locationParking') + translation.language + '*'"
                  name="parking_description"
                  type="text"
                  required
                  v-model="
                    $v.location.translations.$each[k].parking_description.$model
                  "
                  @input="
                    $v.location.translations.$each[
                      k
                    ].parking_description.$touch()
                  "
                  @blur="
                    $v.location.translations.$each[
                      k
                    ].parking_description.$touch()
                  "
                ></v-text-field>
                <v-text-field
                  v-for="(translation, k) in location.translations"
                  :key="'description' + k"
                  :label="
                    $t('locationDescription') + translation.language + '*'
                  "
                  name="description"
                  type="text"
                  required
                  v-model="$v.location.translations.$each[k].description.$model"
                  @input="
                    $v.location.translations.$each[k].description.$touch()
                  "
                  @blur="$v.location.translations.$each[k].description.$touch()"
                ></v-text-field>
                <small>* {{ $t("validation") }}</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="loadLocation(location.id), (dialog = false)"
                  >{{ $t("btnCancel") }}</v-btn
                >
                <v-btn
                  color="green darken-1"
                  :disabled="$v.$invalid"
                  text
                  @click="updateInfo(location)"
                  >{{ $t("btnSave") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <th>{{ $t("locationName") }}</th>
                <td>{{ locationTranslations.name }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationCountry") }}</th>
                <td>{{ location.country.name }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationCity") }}</th>
                <td>{{ location.city }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationAddress") }}</th>
                <td>{{ locationTranslations.address }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationCoordinates") }}</th>
                <td>{{ location.lat }}, {{ location.lng }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationDistance") }}</th>
                <td>{{ locationTranslations.distance }}</td>
              </tr>
              <tr>
                <th>
                  <nobr>{{ $t("locationOpeningTimes") }}</nobr>
                </th>
                <td>{{ locationTranslations.opening_times }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationPayment") }}</th>
                <td>{{ locationTranslations.payment_description }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationParking") }}</th>
                <td>{{ locationTranslations.parking_description }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationDescription") }}</th>
                <td>{{ locationTranslations.description }}</td>
              </tr>
              <tr>
                <th>{{ $t("locationLink") }}</th>
                <th>
                  <a
                    :href="findUrl(location.city_slug)"
                    style="text-decoration: none"
                  >
                    {{ findUrl(location.city_slug) }}
                  </a>
                </th>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import store from "@/store";

export default {
  name: "LocationInfo",

  mixins: [validationMixin],

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  data() {
    return {
      dialog: false,
    };
  },

  mounted() {
    this.loadLocationGeo();
  },

  computed: {
    ...mapGetters(["location", "locationTranslations", "locationGeo"]),
    // locationNameErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].name.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].name.required && errors.push('Необходимо ввести название локации')
    // 	return errors
    // },
    // locationAddressErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].address.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].address.required && errors.push('Необходимо ввести адрес локации')
    // 	return errors
    // },
    // locationLatErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.lat.$dirty) return errors
    // 	!this.$v.location.lat.required && errors.push('Необходимо ввести координаты локации')
    // 	return errors
    // },
    // locationLngErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.lng.$dirty) return errors
    // 	!this.$v.location.lng.required && errors.push('Необходимо ввести координаты локации')
    // 	return errors
    // },
    // locationDistanceErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].distance.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].distance.required && errors.push('Необходимо ввести расстояние локации')
    // 	return errors
    // },
    // locationOpeningTimesErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].opening_times.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].opening_times.required && errors.push('Необходимо ввести время начала работы локации')
    // 	return errors
    // },
    // locationPaymentDescriptionErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].payment_description.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].payment_description.required && errors.push('Необходимо ввести описание оплаты на локации')
    // 	return errors
    // },
    // locationParkingDescriptionErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].parking_description.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].parking_description.required && errors.push('Необходимо ввести описание парковки на локации')
    // 	return errors
    // },
    // locationDescriptionErrors () {
    // 	const errors = []
    // 	if (!this.$v.location.translations.$each[k].description.$dirty) return errors
    // 	!this.$v.location.translations.$each[k].description.required && errors.push('Необходимо ввести описание локации')
    // 	return errors
    // }
  },

  validations: {
    location: {
      translations: {
        $each: {
          name: {
            required,
          },
          address: {
            required,
          },
          distance: {
            required,
          },
          opening_times: {
            required,
          },
          payment_description: {
            required,
          },
          parking_description: {
            required,
          },
          description: {
            required,
          },
        },
      },
      lat: {
        required,
      },
      lng: {
        required,
      },
    },
  },

  methods: {
    ...mapActions(["loadLocation", "loadLocationGeo", "updateLocationInfo"]),
    findUrl(locationCitySlug) {
      if (!Array.isArray(this.locationGeo)) return null;

      for (const location of this.locationGeo) {
        const city =
          Array.isArray(location.cities) &&
          location.cities.find((c) => c.slug === locationCitySlug);
        if (city && (city.domain || city.legacy_redirect_url)) {
          return city.domain || city.legacy_redirect_url;
        }
      }
      return `https://anvio.com/${this.location.country.slug}-${this.locationTranslations.language}/${this.location.city_slug}/`;
    },
    updateInfo(location) {
      this.updateLocationInfo(location);
      this.dialog = false;
    },
  },
};
</script>
